
import createBrowserHistory from "history/createBrowserHistory";
let history = createBrowserHistory();

export const gotoPageWithParams = (page, params) => {
    var serialized = page+serializeParameters(params);
    history.push(serialized);
    history.go(serialized);
}
/*
*   FORMAT
*   page => '/page'
*   params => [ {name: "", value: ""} ]
*/
export const locationSearchToParams = (locationSearch) => {

    if(typeof locationSearch != "string") return null;

    var questionMarkIndex = locationSearch.indexOf("?");

    if( typeof questionMarkIndex < 0 ) return null; //NON CI SONO PARAMETRI

    locationSearch = locationSearch.substring(questionMarkIndex+1);

    var params = [];

    //Splitto in un array dividendo per '&' 
    var values = locationSearch.split('&');

    for( var tmp in values ){
        var equalIndex = values[tmp].indexOf("=");

        if( equalIndex == -1 ) // Non c'e' chiave valore
            equalIndex = values[tmp].length;

        var name  = values[tmp].substring(0, equalIndex);
        var value = values[tmp].substring(equalIndex+1);

        params.push({
             name  : name,
             value : value == "" ? null : value
        });
    }
    
    return params;
}

export const searchInParamsList = (name, list, cast = "string") => {
    var result = null;
    for(var index in list){
        if(list[index].name === name){
            result = list[index].value;
            break;
        }
    }

    if( result === null ) return result;

    switch(cast){
        case 'integer' :
            return parseFloat(result);
            break;
        case 'float' : 
            return parseInt(result);
            break;
        default : 
            return result;
    }
}

/*
*   {simo: "simo", bho : "ciao"}  ====> ?simo=simo&bho=ciao
*/
export const serializeParameters = (object) => {
    var str = "";
    for(var tmp in object){
        var x = object[tmp];
     str += "&" + tmp + (x == null ? "" : "=" + x);   
    }
    //Sostituisco il primo & con ?
    if(str == "")
        return str;
    else
        return "?"+str.substring(1, str.length);
};

/*
*   {simo: "simo", hellas : null , hellas : undefined } => {simo: "simo"}
*/
export const serializeParametersPOST = (object) => {
    var newObj = {};
    for ( var tmp in object ) 
    	if( typeof object[tmp] !== 'undefined' && object[tmp] !== null )
            newObj[tmp] = object[tmp]
    return newObj;
}


// WEBPACK FOOTER //
// ./src/Utils/PagesSwitch.js